<script>
import clientConfig from '/src/config/client';

import {
  MDBContainer, 
  MDBRow, 
  MDBCol
} from "mdb-vue-ui-kit";

export default {
  name: 'NextPanel',

  components: {
    MDBContainer,
    MDBRow,
    MDBCol
  },

  data() {
    return {
      clientConfig
    }
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    }
  }
}
</script>

<template>
  <MDBContainer>
    <MDBRow class="p-0">
      <MDBCol 
        col="12" 
        class="p-4 pb-md-2 text-center" 
        v-html="clientConfig.content.whatsnext.heading"
      >
      </MDBCol>
    </MDBRow>

    <MDBRow class="p-0 pb-5">
      <MDBCol 
        col="12"
        :md="clientConfig.content.whatsnext.showMiddleContent ? '4' : '6'"
        class="p-3 p-md-2 pt-md-4 pb-md-5" 
        :class="clientConfig.content.whatsnext.showMiddleContent ? 'ps-lg-3' : 'ps-md-5'"
        v-html="clientConfig.content.whatsnext.leftColContent"
        >
      </MDBCol>

      <MDBCol 
        v-if="clientConfig.content.whatsnext.showMiddleContent"
        col="12"
        md="4"
        class="p-3 p-md-2 pt-md-4 pb-md-5 px-lg-3" 
        v-html="clientConfig.content.whatsnext.middleColContent"
      >
      </MDBCol>

      <MDBCol 
        col="12"
        :md="clientConfig.content.whatsnext.showMiddleContent ? '4' : '6'"
        class="p-3 p-md-2 pt-md-4 pb-md-5"
        :class="clientConfig.content.whatsnext.showMiddleContent ? 'pe-lg-3' : 'pe-md-5'"
        v-html="clientConfig.content.whatsnext.rightColContent"
      >
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>